import { createLocalStorage } from '~libs.typescript';
import { createLocalStorageState } from '~libs.ui.react';

const PATIENTS_PREFERENCE_PREFIX = 'patients:';
const STORAGE_KEY = `${PATIENTS_PREFERENCE_PREFIX}removedMedicalInformationVisibilityPreference`;

export const useShowRemovedMedicalInformationState = createLocalStorageState(createLocalStorage<boolean>(STORAGE_KEY));
